import { ApiClientModels } from "@/models/api/apiClient.models";
import apiModelsClient from "@/apiClient/models";

const apiClient: ApiClientModels = apiModelsClient;

export default apiClient;
